/**
 * SoDemLoiTat — chấm đỏ mang SỐ ĐẾM đặt trên biểu tượng của widget lối tắt (xem cauHinhSoDem.js).
 *
 * Đếm bằng chính CounterWidget (cùng hàng đợi, cùng cache, cùng cách hỏi API như widget counter), chỉ khác
 * phần vẽ. Hai chỗ phải chủ động nạp lại vì cache của CounterWidget giữ 5–10 phút:
 *   - Mỗi lần widget hiện ra: người dùng vừa ở hộp thư đọc bớt tin rồi quay về dashboard thì phải thấy số
 *     mới, không phải số của năm phút trước.
 *   - Khi có sự kiện socket khai trong `socketEvent` (vd tin nhắn mới tới): gom các sự kiện dồn dập trong
 *     0,8 giây thành MỘT lần đếm — một khách gửi năm tin liền không được thành năm lượt gọi API.
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CounterWidget from './Counter';
import { EmitEvents } from '../utils';
import { cauHinhSoDem, nhanSoDem } from './cauHinhSoDem';

const GOM_MS = 800;

export default function SoDemLoiTat({ widgetConfig, sx }) {
	const ch = cauHinhSoDem(widgetConfig);
	const suKien = ch ? ch.socketEvent : '';
	const [lan, setLan] = useState(0);

	useEffect(() => { setLan((n) => n + 1); }, []);

	useEffect(() => {
		if (!suKien) return undefined;
		const socket = EmitEvents && EmitEvents.socket && EmitEvents.socket.socket;
		if (!socket || typeof socket.on !== 'function') return undefined;
		let hen = null;
		const khiCoSuKien = () => {
			clearTimeout(hen);
			hen = setTimeout(() => setLan((n) => n + 1), GOM_MS);
		};
		socket.on(suKien, khiCoSuKien);
		return () => {
			clearTimeout(hen);
			if (typeof socket.off === 'function') socket.off(suKien, khiCoSuKien);
		};
	}, [suKien]);

	if (!ch) return null;
	return (
		<CounterWidget
			code={ch.apiCode}
			condition={ch.condition}
			refreshTrigger={lan}
			renderRunning={() => null}
			render={(n) => {
				const chu = nhanSoDem(n);
				if (!chu) return null;
				return (
					<Box component="span" title={`${Number(n).toLocaleString('vi-VN')} ${ch.label}`} sx={{
						position: 'absolute', top: -6, right: -10, zIndex: 1,
						minWidth: 20, height: 20, px: 0.6, borderRadius: 10,
						bgcolor: 'error.main', color: '#fff', border: '2px solid #fff',
						fontSize: 11, fontWeight: 700, lineHeight: '16px', textAlign: 'center',
						boxShadow: '0 1px 3px rgba(0,0,0,0.25)', pointerEvents: 'none',
						...(sx || {}),
					}}>
						{chu}
					</Box>
				);
			}}
		/>
	);
}

SoDemLoiTat.propTypes = {
	widgetConfig: PropTypes.object,
	sx: PropTypes.object,
};
